// extracted by mini-css-extract-plugin
export default {"Truncate":"Truncate1OzxBYrNNfH3"};